import React from 'react';

export function SSRTitleScript({ selector }: { selector: string }) {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (!process.env.REACT_SSR) {
		return null;
	}

	const nonceValue = window.__SSR_NONCE_VALUE__;
	const scriptText = `
		requestAnimationFrame(function () {
			const elem = document.querySelector('${selector}');
			if (!elem) return;
			elem.style.height = 'auto';
			elem.style.height = elem.scrollHeight + 'px';
		});
	`;

	return (
		<script
			{...(nonceValue !== undefined ? { nonce: nonceValue } : {})}
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{
				__html: scriptText,
			}}
		/>
	);
}
